import React from "react";

const FreePublication = () => {
  return (
    <React.Fragment>
      <h1>Qualifying for Free Publication</h1>

      <h2>
        <strong> Original Articles, Case Studies, Business Reports, Editorials, and Letters</strong>
      </h2>
      <p>
        Each non-channel Original Article, Business Report, Case Study, Editorial, and Letter
        submission undergoes a preliminary review to determine if the article meets all CJBE
        editorial requirements (as listed in this Author Guide) and qualifies for free publication.
        All non-channel review articles require the purchase of our{" "}
        <a href="/cureus_editing_services" target="_blank" rel="noopener">
          Preferred Editing Service.
        </a>
      </p>
      <p>
        To remain eligible for free publication, articles cannot contain more than the following
        number of authors or references. Exceeding either total will disqualify the article from
        free publication regardless of how many errors are found during our preliminary review.
      </p>
      <ul className="indented-for-medium-up disc">
        <li>Original articles: 30 authors and 200 references</li>
        <li>Business reports/case studies: 30 authors and 200 references</li>
        <li>Editorials: 30 authors and 200 references</li>
        <li>Letters: 30 authors and 200 references</li>
      </ul>

      <h2>
        <strong>All Review Articles Require Preferred Editing</strong>
      </h2>
      <p>
        All{" "}
        <a href="https://www.cureusjournals.com/" target="_blank" rel="noopener">
          non-channel{" "}
        </a>
        / review articles submitted to CJBE will be required to purchase our{" "}
        <a href="/cureus_editing_services" target="_blank" rel="noopener">
          Preferred Editing Service
        </a>{" "}
        to proceed with peer review and likely publication. This is due to the considerable
        editorial expenses associated with processing and editing submitted manuscripts, which
        typically contain more content and references than other articles.
      </p>

      <h2>
        <strong>Editor Check: Preliminary Editorial Review</strong>
      </h2>
      <p>Our preliminary review focuses on the following areas:</p>
      <ul>
        <li>
          <strong>Is this article well-drafted and scientifically credible? </strong>
          Please refer to the{" "}
          <a
            href="/journal/business-and-economics/guide#!/overview/accepted-article-types"
            target="_blank"
            rel="noopener"
          >
            Accepted Article Types
          </a>{" "}
          section
        </li>
        <li>
          <strong>Does this article fit within the journal’s scope? </strong>
          Please study the journal scope by{" "}
          <a href="/specialties" target="_blank" rel="noopener">
            clicking here
          </a>{" "}
          and by selecting your target journal.
        </li>
        <li>
          <strong>Are there errors in the following areas? </strong>
        </li>
        <ul className="indented-for-medium-up disc">
          <li>Reference formatting and accuracy</li>
          <li>Media quality, formatting, labels, and placement</li>
          <li>Spelling, grammar, syntax, and punctuation errors </li>
          <li>Author names and affiliations</li>
          <li>Text and article formatting</li>
          <li>Proper use of acronyms and initialisms</li>
        </ul>
      </ul>
      <p>
        Only well-drafted, relevant, credible submissions with few or no errors will be published
        for free. Articles with too many errors will be required to purchase our Preferred Editing
        Service{" "}
        <a href="/cureus_editing_services" target="_blank" rel="noopener">
          (use our calculator to estimate potential editing fees)
        </a>{" "}
        and articles with severe language issues will require professional language editing by a
        third party to be considered for peer review and free publication in CJBE. Editing tools
        such as Grammarly will not be accepted in place of third-party editing services.
      </p>
    </React.Fragment>
  );
};

export default FreePublication;
